function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable prefer-destructuring */

/* eslint-disable no-plusplus */

/* eslint-disable react/sort-comp */
import React from 'react'; // Based on https://github.com/ShinyChang/react-text-truncate
// Mostly rewritten by ppaskaris for performance and quality.

var DefaultStyle = {};
var reWhitespace = /\s+/g; // An exhaustive expression for hyphenation.
//
// eslint-disable-next-line max-len

var ccHyphenation = "\\u002D\\u058A\\u05BE\\u1400\\u1806\\u2010-\\u2015\\u2E17\\u2E1A\\u2E3A\\u2E3B\\u2E40\\u301C\\u3030\\u30A0\\uFE31\\uFE32\\uFE58\\uFE63\\uFF0D";
var reHyphenated = new RegExp("[^".concat(ccHyphenation, "][").concat(ccHyphenation, "]+$")); // Splits the string on any contiguous whitespace or any word boundary that proceeds a hyphen, producing the following
// after post-processing:
//
//     Input: 'Did you just do a "double-take?"'
//    Output: ['Did', 'you', 'just', 'do', 'a', '"double-', 'take?"']
//
// Post-processing is performed to avoid using a lookbehind assertion, which is not supported in Safari and other Webkit
// browsers.
//
// eslint-disable-next-line max-len

var reTokenize = new RegExp("(\\s+|[".concat(ccHyphenation, "]+\\b)"));
var reHyphenOnly = new RegExp("^[".concat(ccHyphenation, "]+$"));

var TextTruncate =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextTruncate, _React$Component);

  function TextTruncate() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextTruncate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextTruncate)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "scope", undefined);

    _defineProperty(_assertThisInitialized(_this), "canvas", undefined);

    _defineProperty(_assertThisInitialized(_this), "_observer", undefined);

    _defineProperty(_assertThisInitialized(_this), "rafId", undefined);

    _defineProperty(_assertThisInitialized(_this), "prevBoundingClientRectWidth", undefined);

    _defineProperty(_assertThisInitialized(_this), "state", {
      textAfterTruncation: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "_enqueueUpdate", function () {
      if (!_this.rafId) {
        _this.rafId = window.requestAnimationFrame(_this._updateWithinAnimationFrame);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      _this.prevBoundingClientRectWidth = undefined;

      _this._enqueueUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "_observerCallback", function (entries) {
      var entry = entries[0];

      if (_this.prevBoundingClientRectWidth !== entry.boundingClientRect.width) {
        _this.prevBoundingClientRectWidth = entry.boundingClientRect.width;

        _this._enqueueUpdate();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTruncated", function () {
      if (typeof _this.props.onTruncated === 'function') {
        setTimeout(_this.props.onTruncated, 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCalculated", function () {
      if (typeof _this.props.onCalculated === 'function') {
        setTimeout(_this.props.onCalculated, 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_updateWithinAnimationFrame", function () {
      _this.rafId = undefined;

      var textAfterTruncation = _this._truncateTextWithinAnimationFrame();

      if (textAfterTruncation !== _this.state.textAfterTruncation) {
        _this.setState({
          textAfterTruncation: textAfterTruncation
        });
      }

      _this.onCalculated();
    });

    _defineProperty(_assertThisInitialized(_this), "measureWidth", function (text) {
      return _this.canvas.measureText(text).width;
    });

    _defineProperty(_assertThisInitialized(_this), "_setScope", function (scope) {
      _this.scope = scope;
    });

    return _this;
  }

  _createClass(TextTruncate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.scope) {
        window.addEventListener('resize', this.onResize);

        if (this._shouldUseObservers) {
          this._observer = new IntersectionObserver(this._observerCallback, {
            root: null,
            threshold: 0
          });

          this._observer.observe(this.scope);
        } else {
          this._enqueueUpdate();
        }

        var canvas = document.createElement('canvas');
        document.createDocumentFragment().appendChild(canvas);
        this.canvas = canvas.getContext('2d');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.canvas = undefined;

      if (this._observer) {
        this._observer.disconnect();

        this._observer = undefined;
      }

      window.removeEventListener('resize', this.onResize);

      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = undefined;
      }

      this.prevBoundingClientRectWidth = undefined;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this._shouldUseObservers) {
        // In legacy mode, we always enqueue an update when we render, so we don't have to try and be fancy about it.
        return;
      }

      var prevProps = this.props;
      var prevStyle = prevProps.style != null ? prevProps.style : DefaultStyle;
      var nextStyle = nextProps.style != null ? nextProps.style : DefaultStyle;
      var shouldRecalculate = nextProps.text !== prevProps.text || nextStyle.fontStyle !== prevStyle.fontStyle || nextStyle.fontVariant !== prevStyle.fontVariant || nextStyle.fontWeight !== prevStyle.fontWeight || nextStyle.fontSize !== prevStyle.fontSize || nextStyle.fontFamily !== prevStyle.fontFamily || nextProps.containerClassName !== prevProps.containerClassName || nextProps.line !== prevProps.line;

      if (shouldRecalculate) {
        this._enqueueUpdate();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps, nextState) {
      var prevState = this.state;
      var didTruncationChange = nextState.textAfterTruncation !== prevState.textAfterTruncation;

      if (didTruncationChange) {
        var didTruncate = nextState.textAfterTruncation !== nextProps.text;

        if (didTruncate) {
          this.onTruncated();
        }
      } else if (!this._shouldUseObservers) {
        // Legacy behaviour: update on every render. Something might be relying on this, so until we finish the rewrite
        // with ResizeObserver, keep updating on non-noop renders just in case. Note that doing this deferred fixes the
        // original "zero length on display" bug that I set out to fix before I (ppaskaris) got my nose in here.
        //
        // This will not infinitely loop, as a meaningful update will trigger a truncation change, and a noop update will
        // not cause a render.
        this.prevBoundingClientRectWidth = undefined;

        this._enqueueUpdate();
      }
    }
  }, {
    key: "_updateCanvasForMeasure",
    value: function _updateCanvasForMeasure() {
      var _window$getComputedSt = window.getComputedStyle(this.scope),
          fontStyle = _window$getComputedSt['font-style'],
          fontVariant = _window$getComputedSt['font-variant'],
          fontWeight = _window$getComputedSt['font-weight'],
          fontSize = _window$getComputedSt['font-size'],
          fontFamily = _window$getComputedSt['font-family'];

      this.canvas.font = "".concat(fontStyle, " ").concat(fontVariant, " ").concat(fontWeight, " ").concat(fontSize, " ").concat(fontFamily);
    }
  }, {
    key: "_truncateTextWithinAnimationFrame",
    value: function _truncateTextWithinAnimationFrame() {
      var _this$props = this.props,
          line = _this$props.line,
          text = _this$props.text,
          truncateText = _this$props.truncateText;

      if (!this.scope) {
        return undefined;
      } // Cannot rely on this.prevBoundingClientRectWidth due to a blink quirk (it's rounded down).


      var scopeWidth = this.scope.getBoundingClientRect().width; // Return undefined instead of '' because we want non-block-level elements to auto-size themselves when they are made
      // visible.

      if (scopeWidth === 0) {
        return undefined;
      }

      this._updateCanvasForMeasure();

      return TextTruncate.truncate(text, truncateText, scopeWidth, line, this.measureWidth);
    }
  }, {
    key: "getRenderText",
    value: function getRenderText() {
      /* eslint-disable no-unused-vars */
      var _this$props2 = this.props,
          containerClassName = _this$props2.containerClassName,
          element = _this$props2.element,
          line = _this$props2.line,
          onCalculated = _this$props2.onCalculated,
          onTruncated = _this$props2.onTruncated,
          text = _this$props2.text,
          textElement = _this$props2.textElement,
          textTruncateChild = _this$props2.textTruncateChild,
          truncateText = _this$props2.truncateText,
          showTextBeforeTruncation = _this$props2.showTextBeforeTruncation,
          shouldUseObservers = _this$props2.shouldUseObservers,
          props = _objectWithoutProperties(_this$props2, ["containerClassName", "element", "line", "onCalculated", "onTruncated", "text", "textElement", "textTruncateChild", "truncateText", "showTextBeforeTruncation", "shouldUseObservers"]);
      /* eslint-enable no-unused-vars */


      var textAfterTruncation = this.state.textAfterTruncation;

      if (textAfterTruncation == null) {
        return showTextBeforeTruncation ? React.createElement(textElement, props, text) : null;
      }

      if (textAfterTruncation.length <= 0) {
        return null;
      }

      return React.createElement(textElement, props, textAfterTruncation);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          element = _this$props3.element,
          _this$props3$style = _this$props3.style,
          style = _this$props3$style === void 0 ? DefaultStyle : _this$props3$style,
          containerClassName = _this$props3.containerClassName;
      var fontStyle = style.fontStyle,
          fontVariant = style.fontVariant,
          fontWeight = style.fontWeight,
          fontSize = style.fontSize,
          fontFamily = style.fontFamily;
      var renderText = this.getRenderText();
      var rootProps = {
        ref: this._setScope,
        className: containerClassName,
        style: {
          overflow: 'hidden',
          fontStyle: fontStyle,
          fontVariant: fontVariant,
          fontWeight: fontWeight,
          fontSize: fontSize,
          fontFamily: fontFamily
        }
      };
      return React.createElement(element, rootProps, renderText);
    }
  }, {
    key: "_shouldUseObservers",
    get: function get() {
      return Boolean(this.props.shouldUseObservers) && 'IntersectionObserver' in window;
    }
  }], [{
    key: "tokenize",
    value: function tokenize(text) {
      var parts = text.split(reTokenize); // Post-process to avoid lookbehind assertion, which is not supported in Safari and other Webkit browsers. We
      // capture the delimiters we split by to remove the whitespace tokens and left-merge the hyphenations, excluding
      // hyphens that are their own tokens, e.g. "Name - Description"

      var tokens = [];

      for (var i = 0, prevWasWhitespace = false; i < parts.length; ++i) {
        var part = parts[i];

        if (part.length <= 0 || reWhitespace.test(part)) {
          prevWasWhitespace = true;
        } else if (!prevWasWhitespace && reHyphenOnly.test(part)) {
          tokens[tokens.length - 1] += part;
          prevWasWhitespace = false;
        } else {
          tokens.push(part);
          prevWasWhitespace = false;
        }
      }

      return tokens;
    }
  }, {
    key: "truncate",
    value: function truncate(text, ellipsis, maxWidth, maxLines, measureText) {
      if (maxWidth <= 0) {
        return '';
      }

      if (maxLines <= 0) {
        return '';
      }

      var tokens = TextTruncate.tokenize(text);
      var len = tokens.length;
      var delimiter = ' ';
      var delimiterWidth = measureText(delimiter);
      var measureText0 = new Map();
      measureText0.set(delimiter, delimiterWidth);
      var i = 0;
      var result = '';
      var linesRemaining = maxLines;
      var widthRemaining = maxWidth;
      var shouldAppendDelimiter = false; // Basic greedy algorithm with hyphenation support.

      for (i = 0; i < len; ++i) {
        var token = tokens[i];
        var tokenWidth = measureText0.get(token);

        if (tokenWidth == null) {
          tokenWidth = measureText(token);
          measureText0.set(token, tokenWidth);
        }

        if (shouldAppendDelimiter) {
          result += delimiter;
          widthRemaining -= delimiterWidth;
        }

        result += token;
        widthRemaining -= tokenWidth;
        shouldAppendDelimiter = !reHyphenated.test(token);

        if (widthRemaining < 0) {
          linesRemaining -= 1;

          if (linesRemaining <= 0) {
            break;
          }

          widthRemaining = maxWidth - tokenWidth;
        }
      } // If we ran to completion, no truncation was necessary.


      if (i >= len && widthRemaining >= 0) {
        return result;
      }

      var ellipsisWidth = measureText0.get(ellipsis);

      if (ellipsisWidth == null) {
        ellipsisWidth = measureText(ellipsis);
        measureText0.set(ellipsis, ellipsisWidth);
      } // We accumulate error as we wrap. This most commonly manifests on the last line. We'll try rounding up on the final
      // line to mitigate it. We can't do this for earlier lines because the browser will make stuff fit, even snugly. In
      // future, we should measure the full line of text, using binary search as a speed up.


      ellipsisWidth = Math.ceil(ellipsisWidth);
      widthRemaining = Math.floor(widthRemaining); // Reclaim any space necessary to fit the ellipsis.

      if (ellipsisWidth > widthRemaining) {
        var j; // Walk back from the end reclaiming enough space so that the ellipsis fits comfortably. Assumption: we won't have
        // to reclaim too many characters, so repeatedly calling measureText with single characters is ok.

        for (j = result.length - 1; j >= 0 && ellipsisWidth > widthRemaining; --j) {
          var _char = void 0; // This disaster handles surrogate pairs, e.g. emojis 😎


          var charCode = result.charCodeAt(j);

          if (j > 0 && charCode >= 0xdc00 && charCode <= 0xdfff) {
            var charCode0 = result.charCodeAt(j - 1);

            if (charCode0 >= 0xd800 && charCode0 <= 0xdbff) {
              _char = String.fromCharCode(charCode0) + String.fromCharCode(charCode);
              --j;
            }
          }

          if (_char == null) {
            _char = String.fromCharCode(charCode);
          }

          var charWidth = measureText0.get(_char);

          if (charWidth == null) {
            charWidth = measureText(_char);
            measureText0.set(_char, charWidth);
          }

          widthRemaining += charWidth;
        } // Also trim any trailing delimiters.


        while (j > 0 && result.charAt(j) === delimiter) {
          --j;
        }

        result = result.slice(0, j + 1);
      }

      return result + ellipsis;
    }
  }]);

  return TextTruncate;
}(React.Component);

_defineProperty(TextTruncate, "defaultProps", {
  element: 'div',
  line: 1,
  text: '',
  textElement: 'div',
  truncateText: '…',
  showTextBeforeTruncation: true,
  shouldUseObservers: false
});

export { TextTruncate as default };